module.exports = __webpack_public_path__ + "img/logo.1abd2326.svg";